import { Rectangle } from "../../maths/Rectangle";
import { ClassUtils } from "../../utils/ClassUtils";
import { ColorUtils } from '../../utils/ColorUtils';
import { Pool } from "../../utils/Pool";
export class DrawTextureCmd {
    constructor() {
        this.x = 0;
        this.y = 0;
        this.width = 1;
        this.height = 1;
        this.percent = true;
        this.alpha = 1;
        this.color = 0xffffffff;
        this.uv = null;
    }
    static create(texture, x, y, width, height, matrix, alpha, color, blendMode, uv, percent) {
        let cmd = Pool.getItemByClass("DrawTextureCmd", DrawTextureCmd);
        cmd.texture = texture;
        texture && texture._addReference();
        cmd.x = x !== null && x !== void 0 ? x : 0;
        cmd.y = y !== null && y !== void 0 ? y : 0;
        cmd.width = width !== null && width !== void 0 ? width : texture.sourceWidth;
        cmd.height = height !== null && height !== void 0 ? height : texture.sourceHeight;
        cmd.percent = percent;
        cmd.matrix = matrix;
        cmd.alpha = alpha !== null && alpha !== void 0 ? alpha : 1;
        cmd.blendMode = blendMode;
        cmd.uv = uv || null;
        cmd.color = color != null ? ColorUtils.create(color).numColor : 0xffffffff;
        return cmd;
    }
    recover() {
        this.texture && this.texture._removeReference();
        this.texture = null;
        this.matrix = null;
        Pool.recover("DrawTextureCmd", this);
    }
    run(context, gx, gy) {
        let tex = this.texture;
        if (!tex)
            return;
        let x = this.x, y = this.y, w = this.width, h = this.height;
        if (this.percent && context.sprite) {
            x *= context.sprite.width;
            y *= context.sprite.height;
            w *= context.sprite.width;
            h *= context.sprite.height;
        }
        let wRate = w / tex.sourceWidth;
        let hRate = h / tex.sourceHeight;
        w = tex.width * wRate;
        h = tex.height * hRate;
        x += tex.offsetX * wRate;
        y += tex.offsetY * hRate;
        context.drawTextureWithTransform(this.texture, x, y, w, h, this.matrix, gx, gy, this.alpha, this.blendMode, this.uv, this.color);
    }
    getBounds(assembler) {
        let rect = Rectangle.TEMP.setTo(this.x, this.y, this.width, this.height);
        if (this.percent) {
            rect.scale(assembler.width, assembler.height);
            assembler.affectBySize = true;
        }
        rect.getBoundPoints(assembler.points);
    }
    get cmdID() {
        return DrawTextureCmd.ID;
    }
}
DrawTextureCmd.ID = "DrawTexture";
ClassUtils.regClass("DrawTextureCmd", DrawTextureCmd);
